// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".OfferCheckoutReceipt__row___QLmO9{display:flex;justify-content:space-between;align-items:center}", "",{"version":3,"sources":["webpack://./src/webReservations/checkout/OfferCheckoutReceipt.scss"],"names":[],"mappings":"AAAA,mCACE,YAAA,CACA,6BAAA,CACA,kBAAA","sourcesContent":[".row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": "OfferCheckoutReceipt__row___QLmO9"
};
export default ___CSS_LOADER_EXPORT___;
